import { Turbo } from "@hotwired/turbo-rails"

Turbo.StreamActions.remove_with_animation = function () {
  const target = this.getAttribute("target");
  const element = document.getElementById(target);

  element.classList.add("animate-fade-out");

  element.addEventListener("animationend", () => {
    element.remove();
  }, { once: true });
}
